import {Component, Input, OnInit} from '@angular/core';
import {InputBase} from '../input-base';
import {ValueDropdown} from '../../../models/table';

@Component({
  selector: 'cmp-input-dropdown',
  template: `<div class="row">
  <div class="col " *ngIf="textView">
    <div ngbDropdown  class="d-inline-block">
      <button class="btn btn-light" [id]="nameId" ngbDropdownToggle>
        <i *ngIf=" textView.icon" [class]="(textView.icon + ' mr-4 ' + textView.style_icon)"></i>
        {{textView.title}}
      </button>
      <div ngbDropdownMenu [attr.aria-labelledby]="nameId"
           [style.height.px]="dropDownHeight"
           [class.dropdown__overflow]="isDropdownOverflowY">
        <button *ngFor="let val of arrayValue"
                (click)="selectedItem(val.value)"
                class="dropdown-item" type="button">
          <i *ngIf="val.icon" [class]="(val.icon + ' mr-4 ' + val.style_icon)"></i>
          {{val.title}}
        </button>
      </div>
    </div>
  </div>
</div>
`,
  styles: [`.dropdown__overflow{overflow-y:auto}`]
})
export class InputDropdownComponent extends InputBase implements OnInit {
  @Input() title = '';
  @Input() changeTitleBySelected = true;
  @Input() arrayValue: Array<ValueDropdown> = [];
  @Input() dropDownHeight: string | number = ''
  @Input() isDropdownOverflowY = false;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  get textView(): any {
    let retorno = {title: this.title};
    if (this.changeTitleBySelected && this.control) {
      retorno = this.arrayValue.filter(e => {
        return e.value === this.control.value;
      })[0];
      if (!retorno) {
        retorno = {title: '...'};
      }
    } else if (this.changeTitleBySelected) {
      retorno = this.arrayValue.filter(e => e.value === this.model)[0];
      if (!retorno) {
        retorno = {title: '...'};
      }
    }
    return retorno;
  }

  selectedItem(val) {
    if (this.control) {
      this.control.setValue(val);
    } else {
      this.model = val;
    }

    this.outputModel();
  }
}

